import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/internal/Observable';
import { LocalStorageConstants } from 'src/app/common/LocalStorageConstants';

@Injectable({
  providedIn: 'root'
})
export class RentbillService {

  constructor(private http: HttpClient) {
   }

  saveBill(model: any) {
    model.idClient = Number(localStorage.getItem(LocalStorageConstants.CLIENT_ID));
    return this.http.post(environment.apiUrl + 'RentBillMaster/SaveRentBill', model);
  }

  GetAllBill():Observable<any>{
    return  this.http.get(environment.apiUrl + 'RentBillMaster/GetAllRentBill?idClient=' + Number(localStorage.getItem(LocalStorageConstants.CLIENT_ID)));
  }
 
  GetBillById(id):Observable<any>{
    return  this.http.get(environment.apiUrl + 'RentBillMaster/GetRentBillById?id='+id);
  }

  updateBill(model: any) {
    return this.http.patch(environment.apiUrl + 'RentBillMaster/UpdateRentBill', model);
  }

  delete(id: any) {
    return this.http.delete(environment.apiUrl+'RentBillMaster/Delete?id='+id);
  }
}
